import { render } from "./greetings.vue?vue&type=template&id=401e1cf2"
import script from "./greetings.vue?vue&type=script&lang=js"
export * from "./greetings.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__